import styled from 'styled-components';

export const MerchantModal = styled.div`
  padding: ${({ theme }) => `${theme.spacing.x3} ${theme.spacing.x5}`};
`;

export const ParentTable = styled.div`
  background: ${({ theme }) => theme.palette.white};
  box-shadow: 0px 15px 50px rgba(160, 163, 189, 0.1);
  border-radius: 10px;
  padding: ${({ theme }) => theme.spacing.x3};
`;
